import { breakpointsDictMap, breakpointNames } from '../../css/breakpoints';
export const resolveResponsiveRangeFlatPropsOptional = (rangeProps, t, f, undefinedAsFalse) => (rangeProps ? breakpointsDictMap(b => (rangeProps[b] ? t : f)) : undefinedAsFalse ? f : undefined);
export const resolveResponsiveRangePropsOptional = (hide, t, f) => hide ? resolveResponsiveRangeFlatPropsOptional(resolveResponsiveRangeProps(hide), t, f) : undefined;
export const resolveResponsiveRangeProps = (props) => breakpointsDictMap(k => isInRange(k, props));
const isInRange = (value, r) => {
    if (!r.above && !r.below) {
        return false;
    }
    const idx = breakpointNames.indexOf(value);
    const startIndex = r.above ? breakpointNames.indexOf(r.above) + 1 : 0;
    const endIndex = r.below ? breakpointNames.indexOf(r.below) - 1 : breakpointNames.length;
    return startIndex <= idx && idx <= endIndex;
};
